// test607
(607 && 0);
